module.exports = __webpack_public_path__ + "static/index/img/baikal-608.070e2a08.jpg";